<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="dialog">
      <div style="display:flex">
        <v-btn
          v-on="dialog.on"
          @click="onSignClick('tab-1')"
          text
          aria-label="Sign In button"
        >
          Sign In
        </v-btn>
        <v-btn
          v-on="dialog.on"
          @click="onSignClick('tab-2')"
          aria-label="Sign Up button"
          color="blue lighten-4"
          class="black--text"
        >
          Sign Up
        </v-btn>
      </div>
    </template>
    <v-tabs
      v-model="tab"
      background-color="primary"
      class="elevation-2"
      dark
      centered
      grow
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Sign In
        <v-icon>mdi-login</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        Sign Up
        <v-icon>mdi-account-plus</v-icon>
      </v-tab>

      <v-tab-item :value="'tab-2'">
        <SignUp v-on:dialog-closed="dialog = $event" />
      </v-tab-item>

      <v-tab-item :value="'tab-1'">
        <SignIn v-on:dialog-closed="dialog = $event" />
      </v-tab-item>
    </v-tabs>
  </v-dialog>
</template>
<script>
import SignIn from "./SignIn";
import SignUp from "./SignUp";
export default {
  name: "Sign",
  components: { SignIn, SignUp },
  data: () => ({
    dialog: false,
    tab: null,
    tabs: 2,
  }),

  methods: {
    onSignClick(tab) {
      this.tab = tab;
    },
  },
};
</script>
